<template>
  <div class="innerBox">

    <h2 class="mb-4">Daftar Polis Asuransi</h2>
    <panel class="border border-secondary" :noExpand="true">
      <template slot="header">
        <h4 class="panel-title">Filter</h4>
      </template>
      <div class="row outerBox filterBox" style="padding:0 12.5%">
        <div class="col row">
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Cari</label>
            <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
          </div>
          <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
            <label for="partshopCode">Tanggal</label>
            <flat-pickr
              v-model="selected.date"
              :config="rangeConfig"
              placeholder="Pilih Tanggal"
            ></flat-pickr>
          </div>
          <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
            <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
          </div>
        </div>
      </div>
    </panel>

    
    <vue-universal-table
      :special_buttons="vue_universal_table.special_buttons"
      :buttons="vue_universal_table.buttons"
      :dummy_table="false"
      :filter="filter"
      :fields="vue_universal_table.fields"
      :update="vue_universal_table.update"
      api_url="/api/v1/insurance"
      @onPolicyBaru="addInsurance"
      @onEdit="editInsurance"
      @onDelete="deleteInsurance"
    ></vue-universal-table>

	<new-insurance
      v-if="modal.add"
      @closeModal="modal.add = false"
	    :insuranceCompanies="insuranceCompanies"
      @updateTable="vue_universal_table.update++"
    ></new-insurance>

    <edit-insurance
      v-if="modal.edit"
      :editObject="editObject"
	  :insuranceCompanies="insuranceCompanies"
      @closeModal="modal.edit = false"
      @updateTable="vue_universal_table.update++"
    ></edit-insurance>
  </div>
</template>

<script>
  import moment from 'moment'
  
  // Component
  import EditInsurance from './children/editInsurance'
  import NewInsurance from './children/newInsurance'

  export default {
    data () {
      const start = moment().startOf('month').format('YYYY-MM-DD');
      let end  = new moment().format('YYYY-MM-DD')

      return {
        data : null,
        filter: {
          start: start,
          end: end,
          search : '',
          policy : 1
        },
        mobile : this.isMobile(),
        selected : {
          date : `${start} to ${end}`,
        },
        modal : {
          add : false,
          edit : false
        },
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        showNewUserModal : false,
        apiLoading: true,
        vue_universal_table : {
          update: 0,
          special_buttons : ['PolicyBaru'],
          buttons : [
            {
              title : 'Edit',
              class : 'btn-outline-primary fas fa-edit'
            },
            {
              title : 'Delete',
              class : 'btn-outline-danger fa fa-times'
            }
          ],
          fields : [
            {
              title : 'Policy Number',
              variable : 'policy_number'
            },
            {
              title : 'Insurance Company',
              variable : 'insurance_company_name'
            },
            {
              title : 'Customer Name',
              variable : 'insured_name'
            },
            {
              title : 'Nomor Rangka',
              variable : 'chassis_number'
            },
            {
              title : 'Car Type',
              variable : 'car_name'
            },
            {
              title : 'Policy Type',
              variable : 'policy_type_name'
            },
            {
              title : 'Date of Expiry',
              variable : 'policy_expiry'
            }
          ],
          editObject : null,
          insuranceCompanies: null,
          customer_car: null
        }
      }
    },
    components : {
      EditInsurance,
      NewInsurance
    },
    mounted () {
      this.getListOfInsuranceComapny()
      this.getListOfCustomer()
    },
    methods : {
      getListOfCustomer () {
        this.$http.get('/api/v1/masterData/customer?pagination=0')
        .then((resp) => {
          this.customer_car = resp.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      },
      getListOfInsuranceComapny () {
        this.$http.get('/api/v1/insurance/company?pagination=false')
        .then((resp) => {
          this.insuranceCompanies = resp.data.data
        })
        .catch((err) => {
          console.log(err)
        })
      },
      editInsurance (obj) {
        this.editObject = obj
        this.modal.edit = true
      },
      addInsurance () {
        this.modal.add = true
      },
      deleteInsurance (obj) {
        obj = JSON.parse(obj)

        this.$http.delete(`/api/v1/masterData/customer_car/${obj.chassis_number}/${obj.policy_number}`)
        .then((resp) => {
          alert(`Successfully Deleted Policy of Number ${obj.policy_number}`)
          this.vue_universal_table.update++;
        })
        .catch((err) => {
          console.log(err)
        })
      }
    },
    watch : {
      'selected.date'(){
        var date = this.selected.date.split(" to ");
        this.filter.start = date[0]
        this.filter.end = date[1] ? date[1] : date[0]
      }
    }
  }
</script>

<style scoped>
  
</style>